import { PaymentMethodTypes } from '@givebacks/api/core';

import { createSafeContext } from '../../../utils';

const [CartInfoProvider, useCartInfoContext] = createSafeContext<{
  storeId?: string;
  storeItemId?: string;
  cartId?: string;
  pendingCardType?: PaymentMethodTypes;
}>('CartInfoProvider component was not found in tree');

// eslint-disable-next-line react-refresh/only-export-components
export { CartInfoProvider, useCartInfoContext };
